import { find } from 'lodash';
import moment, { Moment } from 'moment';

import type { DateRangeQuickOption } from './types';

export const DateRangeQuickOptions: DateRangeQuickOption[] = [
  {
    label: 'All data',
  },
  {
    label: 'Last 24 hour',
    key: 'LAST_24_HOUR',
    start: 24,
    granularity: 'hour',
  },
  {
    label: 'Last 48 hour',
    key: 'LAST_48_HOUR',
    start: 48,
    granularity: 'hour',
  },
  {
    label: 'Last 7 days',
    key: 'LAST_7_DAYS',
    start: 7,
    granularity: 'days',
  },
  {
    label: 'Last 30 days',
    key: 'LAST_1_MONTH',
    start: 30,
    granularity: 'days',
  },
  {
    label: 'Last 90 days',
    key: 'LAST_3_MONTHS',
    start: 90,
    granularity: 'days',
  },
  {
    label: 'Last 180 days',
    key: 'LAST_6_MONTHS',
    start: 180,
    granularity: 'days',
  },
  {
    label: 'Last month',
    isHidden: true,
    key: 'LAST_1_MONTH',
    start: 30,
    granularity: 'days',
  },
  {
    label: 'Last 3 months',
    isHidden: true,
    key: 'LAST_3_MONTHS',
    start: 90,
    granularity: 'days',
  },
  {
    label: 'Last 6 months',
    isHidden: true,
    key: 'LAST_6_MONTHS',
    start: 180,
    granularity: 'days',
  },
];

export function getStartAndEndDateForQuickOption({
  start = 0,
  end = 0,
  granularity = 'days',
  label,
  utcString = false,
}: {
  start?: number;
  end?: number;
  granularity?: string;
  label?: string;
  utcString?: boolean;
}): [string, string] | [Moment, Moment] | [] {
  if (label) {
    const option = find(DateRangeQuickOptions, { label });
    if (option) {
      start = option.start ?? 0;
      end = option.end ?? 0;
      granularity = (option.granularity as string) ?? 'days';
    }
  }
  if (!start && !end) {
    return [];
  }
  const startDate = moment();
  const endDate = moment();
  if (granularity !== 'hour') {
    startDate.startOf('D');
    endDate.endOf('D');
  }
  startDate.add(-start, granularity as moment.unitOfTime.DurationConstructor);
  endDate.add(-end, granularity as moment.unitOfTime.DurationConstructor);
  if (utcString) {
    return [startDate.utc().format(), endDate.utc().format()];
  }
  return [startDate, endDate];
}
